<div class="layout">
    <div class="toy-container">
        <h1>{{'toys.title' | translate}}</h1>
        <div class="list">
            <div class="tile" *ngFor="let toy of toys">
                <mat-card class="toy-card">
                    <img mat-card-image [src]=toy.img[0] alt="Bild hier" fetchpriority="high">
                    <div class="card-details">
                        <mat-card-title>{{ toy.name | translate}}</mat-card-title>
                        <p class="inclusive-text">
                            <span *ngIf="toy.inclusive; else noFee">{{ toy.inclusive | translate }}</span>
                            <ng-template #noFee>&nbsp;</ng-template>
                        </p>
                        <span class="price-fraction">
                            <mat-card-subtitle>{{ toy.price }}</mat-card-subtitle>
                            <mat-card-subtitle class="fraction">{{ toy.fraction }}</mat-card-subtitle>
                            <span class="material-symbols-outlined price-icon">euro_symbol</span>
                        </span>
                        <button mat-flat-button (click)="openDialog(toy)">{{'toys.moreImages' | translate}}</button>
                        <mat-card-content>
                            <div class="metric"><span class="material-symbols-outlined">straighten</span>
                                {{ toy.size }}
                                <small class="dimension-hint">{{ 'bounceCastle.dimensionsHint' | translate }}</small>
                            </div>
                        </mat-card-content>
                    </div>
                </mat-card>
            </div>
        </div>
    </div>
</div>